import mutations from './mutation';
import getters from './getter';
import actions from './action'
export default {
  state() {
    return {
      clusterDataMiddleware: null,
      clusterDataFormattedMiddleware: null,
      reportsProjMiddleware: null,
      projectsClustMiddleware:null,
      usersSharingMiddleware:null,
      lastErrorMiddleware:'',
      templateDBMiddleware:null,
      projTemplListMiddleware:'',
      templListMiddleware:[],
      newTemplateMiddleware:null,
      extractedDataBinaryMiddleware:null,
      drawCircuitMiddleware: null,
      recommendCircuitMiddleware:null,
			resourceAccessRequestsMiddleware: null,
			totalIncomingPendingAccessRequestsMiddleware:null,
			totalPersonalPendingAccessRequestsMiddleware:null,
			reportAccessTypeMiddleware:null
    }
  },
  mutations,
  getters,
  actions
}
